import { DateTime } from 'luxon';

export const humanizeDate = (dateString) => {
    let suffix = 'th';
    const num = dateString.split('-')[2];
    const lastDigit = num.toString().slice(-1);
  
    switch (lastDigit) {
      case '1':
        suffix = 'st';
        break;
      case '2':
        suffix = 'nd';
        break;
      case '3':
        suffix = 'rd';
        break;
      default:
        break;
    }
  
    if (num === 11 || num === 12 || num === 13) suffix = 'th';
  
    return DateTime.fromFormat(dateString.split('T')[0], 'yyyy-MM-dd').toFormat(`d'${suffix}' LLL yyyy`);
};